'use strict';

var log = require('../../log/Log').channel('AudioBarController');
var sutl = require('../../sutl/Sutl');
var VolumeControlsExtension = require('./VolumeControlsExtension').VolumeControlsExtension;
require('./ClockService');
require('./KayleeService');
require('./RoomService');
require('./SecretKnock');

angular
    .module('inara')
    .directive('aveoAudioBar', function () {
        return {
            restrict: 'E',
            templateUrl: 'audioBar.html',
            controller: 'AudioBarController',
            controllerAs: 'audioBar',
            scope: {
                knockActivated: '=',
            },
        };
    })
    .controller('AudioBarController', AudioBarController);

AudioBarController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    'KayleeService',
    'RoomService',
    '$ionicPopover',
    'gettextCatalog',
    '$window',
    '$ionicPosition',
    'SelectMenuPositionService',
    '$state',
    '$ionicViewSwitcher',
    'ViewStateService',
    '$q',
    'ClockService',
    'IosTouchEventService',
];

function AudioBarController(
    $rootScope,
    $scope,
    $timeout,
    $interval,
    KayleeService,
    RoomService,
    $ionicPopover,
    gettextCatalog,
    $window,
    $ionicPosition,
    SelectMenuPositionService,
    $state,
    $ionicViewSwitcher,
    ViewStateService,
    $q,
    ClockService,
    IosTouchEventService
) {
    var vm = this;
    var clockHeldTimeout = null;
    var configuredCaps = null;
    var firstRoomStateVolume = true;
    var incrementVolume = 0;
    var remoteControlSessions = null;
    var room = null;
    var saveVolume = null;
    var saveVolumeMute = null;
    var site = null;
    var volumeReleasePromise;
    var wchmCaps = ['assistiveListening', 'overflowRooms', 'soundReinforcement'];
    var wchmCapsPropsToStatesProps = { hasMute: 'mute', hasVolume: 'volume' };
    var wchmStatesPropsDefaults = { mute: false, volume: 0 };
    var whoCanHearMeMenu = null;
    var whoCanHearMeMenuPromise = null;
    var wrappedVolumeHandlers = IosTouchEventService.wrapHandlers(
        incrementVolumeTouch,
        incrementVolumeRelease
    );

    log.info('initializing');

    vm.anyWhoCanHearMeHasVolume = anyWhoCanHearMeHasVolume;
    vm.assistiveListeningMute = false;
    vm.getAssistiveListeningLabel = function () {
        /// Who Can Hear Me menu item label for toggle to enable/disable assistive listening
        return gettextCatalog.getString('Assistive Listening');
    };
    vm.getFormattedTime = ClockService.getFormattedTime;
    vm.getRemoteControlCount = getRemoteControlCount;
    vm.getWhoCanHearMeIconClass = getWhoCanHearMeIconClass;
    vm.getWhoCanHearMeLabel = getWhoCanHearMeLabel;
    vm.hasRemoteControlStatus = hasRemoteControlStatus;
    vm.hasRoomVolumeMute = false;
    vm.hasConfiguredWhoCanHearMe = hasConfiguredWhoCanHearMe;
    vm.hasWhoCanHearMe = hasWhoCanHearMe;
    vm.incrementVolumeRelease = wrappedVolumeHandlers.onRelease;
    vm.incrementVolumeTouch = wrappedVolumeHandlers.onTouch;
    vm.isRoomVolumeStateless = false;
    vm.isRoomVolumeIncDec = false;
    vm.isUserChangingVolume = false;
    vm.isVolumeMuted = isVolumeMuted;
    vm.isVolumeHeld = false;
    vm.isWhoCanHearMeActive = isWhoCanHearMeActive;
    vm.minVolume = 0;
    vm.maxVolume = 50;
    vm.mute = false;
    vm.onClockHeld = onClockHeld;
    vm.onClockReleased = onClockReleased;
    vm.onShowRemoteControlStatus = onShowRemoteControlStatus;
    vm.onVolumeChanged = onVolumeChanged;
    vm.onVolumeHold = onVolumeHold;
    vm.onVolumeRelease = onVolumeRelease;
    vm.sendContent = false;
    vm.showWhoCanHearMeMenu = showWhoCanHearMeMenu;
    vm.toggleMute = toggleMute;
    vm.volume = 0;
    vm.volumeMute = false;
    // throttle argument which limits re-rendering of
    // slider when updated via model (such as via increment)
    vm.volumeSliderRenderIntervalMs = 10;
    vm.whoCanHearMeCount = whoCanHearMeCount;
    vm.whoCanHearMeHasVolume = whoCanHearMeHasVolume;
    vm.wchmGetterSetters = {};

    vm.volumeControls = new VolumeControlsExtension(
        $scope,
        $ionicPopover,
        $timeout,
        $window,
        $ionicPosition,
        IosTouchEventService
    );

    createWhoCanHearMeMenu();

    $scope.$on('IdleTimeout', function () {
        hideWhoCanHearMeMenu();
    });

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (!toState.name.includes('control.')) hideWhoCanHearMeMenu();
    });

    $scope.$on('$destroy', function () {
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);
        removeWhoCanHearMeMenu();
        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
        }
    });

    $scope.$on('popover.removed', function ($event, popover) {
        if (popover === whoCanHearMeMenu) whoCanHearMeMenu = null;
    });

    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);

    function anyWhoCanHearMeHasVolume() {
        var key;
        if (sutl.getNode(room, ['configuredCaps', 'assistiveListening', 'hasVolume'], false))
            return true;
        if (vm.soundReinforcement) {
            for (key in vm.soundReinforcement) {
                if (!vm.soundReinforcement.hasOwnProperty(key)) continue;
                if (vm.soundReinforcement[key].hasVolume === true) return true;
            }
        }
        if (vm.overflowRooms) {
            for (key in vm.overflowRooms) {
                if (!vm.overflowRooms.hasOwnProperty(key)) continue;
                if (vm.overflowRooms[key].hasVolume === true) return true;
            }
        }
    }

    function createWhoCanHearMeGetterSetter(roomFnName, roomFnParam, initValue) {
        var _value = initValue;
        return function (value, deviceUpdate) {
            if (arguments.length > 0) {
                _value = value; // set local value immediately
                if (!deviceUpdate && RoomService.online()) {
                    if (angular.isDefined(roomFnParam)) {
                        room[roomFnName](roomFnParam, value);
                    } else {
                        room[roomFnName](value);
                    }
                }
            } else {
                return _value;
            }
        };
    }

    function createWhoCanHearMeMenu() {
        if (whoCanHearMeMenuPromise === null) {
            whoCanHearMeMenuPromise = $ionicPopover
                .fromTemplateUrl('whoCanHearMeMenu.html', {
                    scope: $scope,
                    positionView: SelectMenuPositionService.createPositionViewHandler(),
                })
                .then(function (menu) {
                    whoCanHearMeMenu = menu;
                    return $q.resolve(whoCanHearMeMenu);
                });
        }
        return whoCanHearMeMenuPromise;
    }

    function getRemoteControlCount() {
        if (!hasRemoteControlStatus() || !remoteControlSessions) return 0;
        return remoteControlSessions.filter(function (session) {
            return session.expires > Date.now();
        }).length;
    }

    function getWhoCanHearMeIconClass() {
        var classNames = getDefaultIconClasses();
        if (room.settings.whoCanHearMeIcon) {
            switch (room.settings.whoCanHearMeIcon) {
                case 'toggles':
                    classNames = 'ion-ios-toggle'; // no mute color change
                    break;
                case 'megaphone':
                default:
                    classNames = getDefaultIconClasses();
                    break;
            }
        }
        return classNames;

        function getDefaultIconClasses() {
            return whoCanHearMeCount() === 0
                ? 'ion-aveo-megaphone-off muted'
                : 'ion-aveo-megaphone';
        }
    }

    function getWhoCanHearMeLabel() {
        /// Button label for the 'Who Can Hear Me' menu - a list of assistive listening, sound reinforcement zones, and overflow rooms that can 'hear me'
        return room.settings.whoCanHearMeLabel && room.settings.whoCanHearMeLabel.length > 0
            ? room.settings.whoCanHearMeLabel
            : gettextCatalog.getString('Who Can Hear Me');
    }

    function hasConfiguredWhoCanHearMe() {
        if (room === null) return false;

        return (
            room.configuredCaps.assistiveListening ||
            Object.values(sutl.getNode(room.configuredCaps, 'overflowRooms', {})).some(cap => !cap.isHidden) ||
            Object.values(sutl.getNode(room.configuredCaps, 'soundReinforcement', {})).some(cap => !cap.isHidden)
        );
    }

    function hasRemoteControlStatus() {
        return (
            site &&
            site.$isLoaded() &&
            site.settings.remoteControlEnabled &&
            KayleeService.isConnected()
        );
    }

    function hasWhoCanHearMe() {
        if (room === null) return false;

        return (
            room.caps.assistiveListening || room.caps.overflowRooms || room.caps.soundReinforcement
        );
    }

    function hideWhoCanHearMeMenu() {
        if (whoCanHearMeMenuPromise !== null) {
            whoCanHearMeMenuPromise.then(function (menu) {
                if (menu.isShown()) menu.hide();
            });
        }
    }

    function incrementVolumeRelease($event) {
        vm.isIncrementVolumeHeld = false;
        scheduleVolumeRelease();
    }

    function incrementVolumeTouch($event, increment) {
        if (!angular.isDefined(increment)) {
            increment = 1;
        }
        if (!vm.isRoomVolumeStateless) {
            if (!vm.isIncrementVolumeHeld) {
                incrementVolume = vm.volume;
            }
            incrementVolume = Math.max(
                vm.minVolume,
                Math.min(vm.maxVolume, incrementVolume + increment)
            );
        }
        if (vm.isRoomVolumeIncDec) {
            incrementVolume = increment;
        }
        saveVolume = null;
        saveVolumeMute = null;
        if (!vm.isRoomVolumeStateless) {
            vm.volume = incrementVolume;
            setUiMuteVolume(vm.volume);
        }
        vm.isIncrementVolumeHeld = true;
        vm.isUserChangingVolume = true;
        setVolume(incrementVolume);
    }

    function isVolumeMuted() {
        return vm.hasRoomVolumeMute && vm.volumeMute;
    }

    function isWhoCanHearMeActive() {
        return whoCanHearMeMenu && whoCanHearMeMenu.isShown();
    }

    function onClockHeld() {
        if (angular.isDefined($window.cordova)) {
            clockHeldTimeout = $timeout(function () {
                $rootScope.$broadcast('SleepService', 'startClean');
            }, 4500);
        }
    }

    function onClockReleased() {
        if (clockHeldTimeout !== null) {
            $timeout.cancel(clockHeldTimeout);
            clockHeldTimeout = null;
        }
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
            remoteControlSessions = room.$getRemoteControlSessions();
            site = KayleeService.getSite(room.siteId);
        } else {
            hideWhoCanHearMeMenu();
            if (room !== null) {
                room.$offChange(onRoomChanged);
                room = null;
            }
            remoteControlSessions = null;
            if (site !== null) site = null;
            configuredCaps = null;
        }
    }

    function onRoomChanged() {
        if (!RoomService.online()) return;
        vm.hasConfiguredMicrophoneMute = room.configuredCaps.hasMicrophoneMute;
        vm.hasMicrophoneMute = room.caps.hasMicrophoneMute;
        vm.hasConfiguredRoomVolume = room.configuredCaps.hasRoomVolume;
        vm.isRoomVolumeIncDec = room.configuredCaps.isRoomVolumeIncDec;
        vm.isRoomVolumeStateless = room.configuredCaps.isRoomVolumeStateless;
        vm.hasRoomVolume = room.caps.hasRoomVolume;
        vm.mute = room.states.roomMute;
        vm.hasRoomVolumeMute = room.caps.hasRoomVolumeMute;

        if (hasWhoCanHearMe()) {
            updateWhoCanHearMe();
        } else {
            hideWhoCanHearMeMenu();
            vm.volumeControls.hideVolumeControls();
        }

        if (vm.isUserChangingVolume) {
            saveVolume = room.states.roomVolume;
            if (vm.hasRoomVolumeMute) {
                saveVolumeMute = room.states.roomVolumeMute;
            }
            scheduleVolumeRelease();
        } else {
            if (!vm.isRoomVolumeStateless) {
                vm.volume = room.states.roomVolume;
            }
            if (vm.hasRoomVolumeMute) {
                vm.volumeMute = room.states.roomVolumeMute;
            }
        }
        if (firstRoomStateVolume && !vm.isRoomVolumeStateless) {
            firstRoomStateVolume = false;
            $scope.$broadcast('rzSliderForceRender');
        }
    }

    function onVolumeChanged(sliderId, value) {
        if (vm.isVolumeHeld) {
            setUiMuteVolume(value);
            setVolume(value);
        }
    }

    function onVolumeHold() {
        vm.isVolumeHeld = true;
        vm.isUserChangingVolume = true;
        saveVolume = null;
        saveVolumeMute = null;
    }

    function releaseVolume() {
        if (!vm.isVolumeHeld) {
            vm.isUserChangingVolume = false;
            if (saveVolume !== null) {
                vm.volume = saveVolume;
            }
            if (saveVolumeMute !== null) {
                vm.volumeMute = saveVolumeMute;
            }
        }
    }

    function onShowRemoteControlStatus($event) {
        $ionicViewSwitcher.nextDirection('forward');
        $state.go('control.remote');
    }

    function onVolumeRelease() {
        vm.isVolumeHeld = false;
        scheduleVolumeRelease();
    }

    function removeWhoCanHearMeMenu() {
        if (whoCanHearMeMenuPromise !== null) {
            whoCanHearMeMenuPromise.then(function (menu) {
                menu.remove();
            });
        }
    }

    function scheduleVolumeRelease() {
        $timeout.cancel(volumeReleasePromise);
        volumeReleasePromise = $timeout(releaseVolume, 400);
    }

    function setUiMuteVolume(volume) {
        if (vm.hasRoomVolumeMute) {
            vm.volumeMute = volume <= 0;
        }
    }

    function setVolume(newValue) {
        if (RoomService.online() && room !== null) {
            room.$requestRoomVolume(newValue);
        }
    }

    function showWhoCanHearMeMenu($event) {
        createWhoCanHearMeMenu().then(function (menu) {
            return menu.show($event);
        });
    }

    function toggleMute() {
        if (RoomService.online() && room !== null) {
            vm.mute = !vm.mute;
            room.$requestRoomMute(vm.mute);
        }
    }

    function updateWhoCanHearMe() {
        var key;
        var prop;
        var setter;

        if (!RoomService.online()) return;

        if (
            configuredCaps === null ||
            !sutl.objEquals(
                room.configuredCaps.assistiveListening,
                configuredCaps.assistiveListening
            ) ||
            !sutl.objEquals(room.configuredCaps.overflowRooms, configuredCaps.overflowRooms) ||
            !sutl.objEquals(
                room.configuredCaps.soundReinforcement,
                configuredCaps.soundReinforcement
            )
        ) {
            configuredCaps = angular.copy(room.configuredCaps);

            // need to copy who can hear me items which will be converted to array
            // in template
            vm.overflowRooms = angular.copy(configuredCaps.overflowRooms);

            for (key in vm.overflowRooms) {
                if (!vm.overflowRooms.hasOwnProperty(key)) continue;
                if (vm.overflowRooms[key].isHidden) {
                    delete vm.overflowRooms[key];
                }
            }

            vm.soundReinforcement = angular.copy(configuredCaps.soundReinforcement);

            for (key in vm.soundReinforcement) {
                if (!vm.soundReinforcement.hasOwnProperty(key)) continue;
                if (vm.soundReinforcement[key].isHidden) {
                    delete vm.soundReinforcement[key];
                }
            }

            // hide menu and re-create mute/volume getters/setters if who can hear me
            // configuration has changed
            hideWhoCanHearMeMenu();

            vm.wchmGetterSetters = {};
            for (var cap in room.configuredCaps) {
                if (room.configuredCaps.hasOwnProperty(cap) && wchmCaps.includes(cap)) {
                    if (
                        Object.keys(room.configuredCaps[cap]).some(
                            wchmCapsPropsToStatesPropsIncludes
                        )
                    ) {
                        // single item, update it
                        for (prop in wchmCapsPropsToStatesProps) {
                            if (!wchmCapsPropsToStatesProps.hasOwnProperty(prop)) continue;
                            if (room.configuredCaps[cap][prop] !== true) continue;
                            if (!angular.isDefined(vm.wchmGetterSetters[cap]))
                                vm.wchmGetterSetters[cap] = {};
                            if (room.configuredCaps[cap].isHidden) continue;
                            vm.wchmGetterSetters[cap][
                                wchmCapsPropsToStatesProps[prop]
                            ] = createWhoCanHearMeGetterSetter(
                                buildRequestFnName(cap, wchmCapsPropsToStatesProps[prop]),
                                undefined,
                                sutl.getNode(
                                    room,
                                    ['states', cap, wchmCapsPropsToStatesProps[prop]],
                                    wchmStatesPropsDefaults[wchmCapsPropsToStatesProps[prop]]
                                )
                            );
                        }
                    } else {
                        // process Firebase-style array
                        for (key in room.configuredCaps[cap]) {
                            if (!room.configuredCaps[cap].hasOwnProperty(key)) continue;
                            for (prop in wchmCapsPropsToStatesProps) {
                                if (!wchmCapsPropsToStatesProps.hasOwnProperty(prop)) continue;
                                if (room.configuredCaps[cap][key][prop] !== true) continue;
                                if (!angular.isDefined(vm.wchmGetterSetters[cap]))
                                    vm.wchmGetterSetters[cap] = {};
                                if (!angular.isDefined(vm.wchmGetterSetters[cap][key]))
                                    vm.wchmGetterSetters[cap][key] = {};
                                if (room.configuredCaps[cap][key].isHidden) continue;
                                vm.wchmGetterSetters[cap][key][
                                    wchmCapsPropsToStatesProps[prop]
                                ] = createWhoCanHearMeGetterSetter(
                                    buildRequestFnName(cap, wchmCapsPropsToStatesProps[prop]),
                                    key,
                                    sutl.getNode(
                                        room,
                                        ['states', cap, key, wchmCapsPropsToStatesProps[prop]],
                                        wchmStatesPropsDefaults[wchmCapsPropsToStatesProps[prop]]
                                    )
                                );
                            }
                        }
                    }
                }
            }

            $scope.$broadcast('WhoCanHearMeInit');
        }

        // update changed mute/volume states
        for (var state in room.states) {
            if (room.states.hasOwnProperty(state) && wchmCaps.includes(state)) {
                if (Object.keys(room.states[state]).some(wchmStatesPropsDefaultsIncludes)) {
                    // single item, update it
                    for (prop in wchmStatesPropsDefaults) {
                        if (!wchmStatesPropsDefaults.hasOwnProperty(prop)) continue;
                        setter = sutl.getNode(vm.wchmGetterSetters, [state, prop], null);
                        if (setter === null) continue;
                        setter(
                            sutl.getNode(
                                room,
                                ['states', state, prop],
                                wchmStatesPropsDefaults[prop]
                            ),
                            true
                        );
                    }
                } else {
                    // process Firebase-style array
                    for (key in room.states[state]) {
                        if (!room.states[state].hasOwnProperty(key)) continue;
                        for (prop in wchmStatesPropsDefaults) {
                            if (!wchmStatesPropsDefaults.hasOwnProperty(prop)) continue;
                            setter = sutl.getNode(vm.wchmGetterSetters, [state, key, prop], null);
                            if (setter === null) continue;
                            setter(
                                sutl.getNode(
                                    room,
                                    ['states', state, key, prop],
                                    wchmStatesPropsDefaults[prop]
                                ),
                                true
                            );
                        }
                    }
                }
            }
        }

        function buildRequestFnName(cap, prop) {
            // From an element in the caps (e.g. assistiveListening) and the
            // property requested (e.g. mute) build the corresponding room
            // request function name (e.g. $requestAssistiveListeningMute).
            //
            // There is a special case for pluralized caps
            // (e.g. overflowRooms) where we need to remove the plural ending
            // to match the real room request function name
            // (e.g. $requestOverflowRoomMute)
            var name =
                '$request' +
                cap.slice(0, 1).toUpperCase() +
                cap.slice(1, cap.charAt(cap.length - 1) === 's' ? cap.length - 1 : cap.length) +
                prop.slice(0, 1).toUpperCase() +
                prop.slice(1);
            log.debug(name);
            return name;
        }
    }

    function wchmCapsPropsToStatesPropsIncludes(value) {
        return Object.keys(wchmCapsPropsToStatesProps).includes(value);
    }

    function wchmStatesPropsDefaultsIncludes(value) {
        return Object.keys(wchmStatesPropsDefaults).includes(value);
    }

    function whoCanHearMeCount() {
        var count = 0;
        var prop;

        for (var state in vm.wchmGetterSetters) {
            if (!vm.wchmGetterSetters.hasOwnProperty(state)) continue;
            if (Object.keys(vm.wchmGetterSetters[state]).some(wchmStatesPropsDefaultsIncludes)) {
                // single item, update it
                for (prop in wchmStatesPropsDefaults) {
                    if (!wchmStatesPropsDefaults.hasOwnProperty(prop)) continue;
                    if (!vm.wchmGetterSetters[state].hasOwnProperty(prop)) continue;
                    if (vm.wchmGetterSetters[state][prop]() === false) count++;
                }
            } else {
                // process Firebase-style array
                for (var key in vm.wchmGetterSetters[state]) {
                    if (!vm.wchmGetterSetters[state].hasOwnProperty(key)) continue;
                    for (prop in wchmStatesPropsDefaults) {
                        if (!wchmStatesPropsDefaults.hasOwnProperty(prop)) continue;
                        if (!vm.wchmGetterSetters[state][key].hasOwnProperty(prop)) continue;
                        if (vm.wchmGetterSetters[state][key][prop]() === false) count++;
                    }
                }
            }
        }

        return count;
    }

    function whoCanHearMeHasVolume(item) {
        return item && item.hasVolume === true;
    }
}

module.exports = AudioBarController;
